import {OnlineTeammate} from '../../../models/push/onlineTeammateModel';
import {AppAction} from '../../appActions';
import {OnlineTeammatesActionsEnum} from './onlineTeammatesActions';

export function onlineTeammatesReducer(state: ReadonlyArray<OnlineTeammate> | undefined, action: AppAction) {
  switch (action.type) {
    case OnlineTeammatesActionsEnum.SET_ONLINE_TEAMMATES:
      return action.payload;

    default:
      return state;
  }
}
